import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const documentIdResolver: FieldResolver = (metadata: Metadata) =>
  ({ documentId: metadata.getDocumentId() } as StreamData)

export default documentIdResolver
